import React from 'react';
import { View, StyleSheet } from 'react-native';
import Svg, { Defs, Pattern, Circle, Rect } from 'react-native-svg';
import { useTheme } from '../contexts/ThemeContext';

// Fundo "minimal premium dashboard": canvas claro + padrao pontilhado sutil (theme-aware).
// Modo claro: canvas #F5F5F5 + pontos cinza bem fracos.
// Modo escuro: mantem o fundo escuro do tema com pontos claros quase imperceptiveis.
// Padrao tileado via SVG <Pattern> (estatico, atras do conteudo, sem custo de re-render no scroll).
const DOT_SPACING = 14;

const DottedBackground = ({ children, style }) => {
  const { theme, isDarkMode } = useTheme();

  const canvasColor = isDarkMode ? theme.colors.background : '#F5F5F5';
  const dotColor = isDarkMode ? '#FFFFFF' : '#9CA3AF';
  const dotOpacity = isDarkMode ? 0.09 : 0.26;

  return (
    <View style={[{ flex: 1, backgroundColor: canvasColor }, style]}>
      <Svg style={StyleSheet.absoluteFill} pointerEvents="none">
        <Defs>
          <Pattern
            id="dottedBackgroundDots"
            patternUnits="userSpaceOnUse"
            width={DOT_SPACING}
            height={DOT_SPACING}
          >
            <Circle cx={1} cy={1} r={1} fill={dotColor} opacity={dotOpacity} />
          </Pattern>
        </Defs>
        <Rect x="0" y="0" width="100%" height="100%" fill="url(#dottedBackgroundDots)" />
      </Svg>
      {children}
    </View>
  );
};

export default DottedBackground;
